var React = require('react');

function MenuBars (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 16.4763H25V13.7815H0V16.4763ZM0 9.73933H25V7.04452H0V9.73933ZM0 0.307495V3.0023H25V0.307495H0Z"}));
}

MenuBars.defaultProps = {"width":"25","height":"17","viewBox":"0 0 25 17"};

module.exports = MenuBars;

MenuBars.default = MenuBars;
